import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BookingMSCDetails = () => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('Bookingmscdetails');
    const [data, setData] = useState(undefined);
    const [selectedBookingItem, setSelectedBookingItem] = useState('');
    const [bookinNOList, setBookinNOList] = useState(undefined);
    const [customerList, setCustomerList] = useState(undefined);
    const [curruntBookingNO, setCurruntBookingNO] = useState('');
    const [selectedCUS, setSelectedCUS] = useState(['']);
    const [cusCode, setCusCode] = useState('');
    const [volume, setVolume] = useState('');
    const [blNUM, setBlNUM] = useState('');
    const [container, setcontainer] = useState('');
    const [reMark, setReMark] = useState('');
    const [emptyInput, setEmptyInput] = useState(false);
    const [emptyVolume, setEmptyVolume] = useState(false);
    const [emptyCustomers, setEmptyCustomers] = useState(false);
    const [emptyBl, setEmptyBl] = useState(false);
    const [emptyContainers, setEmptyContainers] = useState(false);
    const [emptyRemark, setEmptyRemark] = useState(false);



    useEffect(() => {
        fetch(`${baseUrl}bookingcosting/getbookingno`)
            .then(response => response.json())
            .then(data => {
                setBookinNOList(data.bookingno);
                console.log(data)
            })
            .catch(error => {
                alert(error());
            })

    }, [])

    useEffect(() => {
        fetch(`${baseUrl}bookingcosting/customerdropdown`)
            .then(response => response.json())
            .then(data => {
                setCustomerList(data.customer);
            })
            .catch(error => {
                alert(error());
            })
    }, [])

    useEffect(() => {
        fetch(`http://mol.evolve-demo.com/api/bookingcosting/getbookingno`)
            .then(response => response.json())
            .then(data => {
                setBookinNOList(data.bookingno);

            })
            .catch(error => {
                alert(error());
            })

    }, [])

    const selectBookingNO = (bkNO) => {
        setSelectedCUS(['']);
        let cusNO = bkNO;
        setCurruntBookingNO(cusNO);
        fetch(`${baseUrl}${pageComponent}/getcustomer/${cusNO}`)
            .then(response => response.json())
            .then(data => {
                setSelectedCUS(data.booking);
            })
            .catch(error => {
                alert(error());
            })
    }

    const handleSave = async (event) => {
        event.preventDefault();
        setEmptyVolume(false);
        const inputData = { BookingNo: curruntBookingNO, CustCode: cusCode, BLNos: blNUM, ContNo: container, CustVolums: volume, Remark: reMark };
        if (volume.length == 0) {
            toast.error("Volume can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyVolume(true);
            setEmptyInput(true);
        } else {
            setEmptyVolume(false);
        }

        if (cusCode.length == 0) {
            toast.error("Customer can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyCustomers(true);
            setEmptyInput(true);
        } else {
            setEmptyCustomers(false);
        }

        if (blNUM.length == 0) {
            toast.error("BL Number can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyBl(true);
            setEmptyInput(true);
        } else {
            setEmptyBl(false);
        }

        if (container.length == 0) {
            toast.error("Container can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyContainers(true);
            setEmptyInput(true);
        } else {
            setEmptyContainers(false);
        }

        if (reMark.length == 0) {
            toast.error("Remark can not be empty", {
                position: toast.POSITION.TOP_RIGHT
            });
            setEmptyRemark(true);
            setEmptyInput(true);
        } else {
            setEmptyRemark(false);
        }

        if (emptyInput !== true) {

            axios.post(`http://mol.evolve-demo.com/api/bookingmcsdetails/store`, inputData)
                .then(response => {
                    console.log(response)
                    toast.success('Successfully Saved Data ! ', {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    setTimeout(window.location.reload.bind(window.location), 2000);

                })
                .catch(error => {
                    toast.error("error", {
                        position: toast.POSITION.TOP_RIGHT
                    });

                });
        } else {

        }
    }



    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row>
                <Col>
                    <Form className='mt-3 bottom-border pb-3'>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="Vessel">
                                    <Form.Label>Booking No {curruntBookingNO}</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={e => { selectBookingNO(e.target.value) }}>
                                        <option></option>
                                        {
                                            Array.isArray(bookinNOList) ? bookinNOList.map((bookNOItem, id) => (
                                                <option value={bookNOItem.BookingNo} key={id}>{bookNOItem.BookingNo}</option>
                                            )) : ''
                                        }

                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupvolum">
                                    <Form.Label>Volume {volume}</Form.Label>
                                    <Form.Control type="text" placeholder="" name="countrycode" value={volume} className={emptyVolume == true ? 'border-red2' : ''} onChange={e => setVolume(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="Vessel">
                                    <Form.Label>Customers {cusCode}</Form.Label>
                                   
                                    <Form.Select aria-label="Default select example" onChange={e => setCusCode(e.target.value)} className={emptyCustomers == true ? 'border-red2' : ''}>
                                    <option></option>
                                        {customerList !== undefined ? customerList.map((customerItem, id) => (

                                            <option value={customerItem.Cus_id} key={id}>{customerItem.Cus_name}</option>

                                        )) : ''

                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail" >
                                    <Form.Label>BL Nos. {blNUM}</Form.Label>
                                    <Form.Control as="textarea" placeholder="BL Nos. here" className={emptyBl == true ? 'border-red2' : ''} value={blNUM} onChange={e => setBlNUM(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Containers {container}</Form.Label>
                                    <Form.Control as="textarea" placeholder="Containers here" className={emptyContainers == true ? 'border-red2' : ''} value={container} onChange={e => setcontainer(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Remark {reMark}</Form.Label>
                                    <Form.Control as="textarea" placeholder="Remark here" className={emptyRemark == true ? 'border-red2' : ''} value={reMark} onChange={e => setReMark(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='text-center'>
                            <Col className='text-end'>
                                <Button className="ms-3" variant="primary" onClick={handleSave}>
                                    Save
                                </Button>
                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

        </Container>
    );

}


export default BookingMSCDetails;